import { render, staticRenderFns } from "./AsuDownload.vue?vue&type=template&id=0166ed1f&scoped=true&lang=pug&"
import script from "./AsuDownload.vue?vue&type=script&lang=js&"
export * from "./AsuDownload.vue?vue&type=script&lang=js&"
import style0 from "./AsuDownload.vue?vue&type=style&index=0&id=0166ed1f&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0166ed1f",
  null
  
)

export default component.exports